import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InstallationTable from "../components/Marketplace/InstallationTable";
import { getMarketplaceApps } from "../api/marketplaceApi";

// Install / update / uninstall history of the marketplace apps. It used to sit above the app cards on the Marketplace screen;
// that screen now shows only the apps.
export default function MarketplaceHistory() {
  const { t } = useTranslation();
  const accessToken = useSelector((s) => s.session?.accessToken);
  const me = useSelector((s) => s.session?.me);
  const navigate = useNavigate();
  const [apps, setApps] = useState([]);
  const superadmin = me?.global_role === "superadmin";

  useEffect(() => {
    getMarketplaceApps(accessToken)
      .then((r) => setApps(Array.isArray(r) ? r : r?.items || []))
      .catch(() => setApps([]));
  }, [accessToken]);

  return (
    <Box sx={{ p: 3, color: "var(--text-primary)" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>{t("marketplace.history.title")}</Typography>
        <Button size="small" variant="outlined" onClick={() => navigate("/marketplace")}>Marketplace</Button>
      </Box>
      <InstallationTable
        accessToken={accessToken}
        apps={apps}
        title={superadmin ? t("marketplace.history.tableAll") : t("marketplace.history.tableFailed")}
        lockKind={superadmin ? undefined : "failed"}
      />
    </Box>
  );
}
